var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',_vm._g(_vm._b({staticClass:"base__datatable",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-data-table',[_vm.$attrs, _vm.$props],false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }